import { createContactMessage } from "@/business/contact/application/createContactMessage";
import { ref, Ref } from "vue";

export function contactUsUse() {


    const showContactModal = ref(false);

    const openContactModal = () => {
        showContactModal.value = true;
        document.body.style.overflow = 'hidden';
    };

    const closeContactModal = () => {
        showContactModal.value = false;
        document.body.style.overflow = 'auto';
    };

    async function contactFormOperation(
        name: string,
        email: string,
        phone: string,
        message: string,
    ): Promise<void> {
        await createContactMessage.execute(
            name,
            email,
            phone,
            message
        );
    }

    return {
        showContactModal,
        openContactModal,
        closeContactModal,
        contactFormOperation
    };
}
